import { render } from "./Panel.vue?vue&type=template&id=6e907fb2"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=6e907fb2&lang=css"
script.render = render

export default script